import * as React from 'react';
import * as styles from './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FiltersLayout = function FiltersLayout(_ref) {
  var filtersPanel = _ref.filtersPanel,
    floorsPanel = _ref.floorsPanel;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    "data-testid": "filters",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['filters'],
      children: filtersPanel
    }), /*#__PURE__*/_jsx("div", {
      className: styles['floors'],
      children: floorsPanel
    })]
  });
};